import { render, staticRenderFns } from "./iconChatbot.vue?vue&type=template&id=6b869afe&scoped=true&"
import script from "./iconChatbot.vue?vue&type=script&lang=js&"
export * from "./iconChatbot.vue?vue&type=script&lang=js&"
import style0 from "./iconChatbot.vue?vue&type=style&index=0&id=6b869afe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b869afe",
  null
  
)

export default component.exports